import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conselho-fiscal',
  templateUrl: './conselho-fiscal.component.html',
  styleUrls: ['./conselho-fiscal.component.css']
})
export class ConselhoFiscalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
